import React from "react";

export const BasketIcon = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.666626 0.666656L1.46663 3.33332M1.46663 3.33332L4.66663 14H19.3333V5.99999C19.3333 4.52723 18.1394 3.33332 16.6666 3.33332H1.46663ZM11.3333 5.33332V12M7.99996 8.66666H14.6666M16.6666 19.3333C15.9302 19.3333 15.3333 18.7364 15.3333 18C15.3333 17.2636 15.9302 16.6667 16.6666 16.6667C17.403 16.6667 18 17.2636 18 18C18 18.7364 17.403 19.3333 16.6666 19.3333ZM5.99996 18C5.99996 17.2636 6.59691 16.6667 7.33329 16.6667C8.06967 16.6667 8.66663 17.2636 8.66663 18C8.66663 18.7364 8.06967 19.3333 7.33329 19.3333C6.59691 19.3333 5.99996 18.7364 5.99996 18Z"
        stroke="white"
      />
    </svg>
  );
};
